import { forwardRef, ReactNode } from 'react';

type P = {
  isTablet: boolean;
  searchComponent?: ReactNode;
  sortComponent?: ReactNode;
  modalComponent?: ReactNode;
};

const SearchContainer = forwardRef<HTMLDivElement, P>(
  ({ searchComponent, sortComponent, modalComponent }, ref) => {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{ position: 'relative', width: '100%', flex: '1' }}
            ref={ref}
          >
            {searchComponent}
          </div>
          {sortComponent}
        </div>
        {modalComponent}
      </div>
    );
  },
);

SearchContainer.displayName = 'SearchContainer';

export default SearchContainer;
